const INSTANCE_DOM_ID_CHARS = /[^a-zA-Z0-9_-]/g;
const HYPHEN_RUNS = /-+/g;
const EDGE_HYPHENS = /^-|-$/g;
const LABEL_SLUG_CHARS = /[^a-z0-9]+/g;

export function sanitizeInstanceDomIdSegment(value: string, fallback: string): string {
  return (
    value.replace(INSTANCE_DOM_ID_CHARS, '-').replace(HYPHEN_RUNS, '-').replace(EDGE_HYPHENS, '') ||
    fallback
  );
}

export function sanitizeOptionalInstanceDomIdSegment(value: string): string {
  return value
    .replace(INSTANCE_DOM_ID_CHARS, '-')
    .replace(HYPHEN_RUNS, '-')
    .replace(EDGE_HYPHENS, '');
}

export function accordionLabelToDomIdSegment(value: string, fallback: string): string {
  return (
    value.trim().toLowerCase().replace(LABEL_SLUG_CHARS, '-').replace(EDGE_HYPHENS, '') || fallback
  );
}
